import { render, staticRenderFns } from "./catchingDolls.vue?vue&type=template&id=4d5c7e48&scoped=true"
import script from "./catchingDolls.vue?vue&type=script&lang=js"
export * from "./catchingDolls.vue?vue&type=script&lang=js"
import style0 from "./catchingDolls.vue?vue&type=style&index=0&id=4d5c7e48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5c7e48",
  null
  
)

export default component.exports